import styled from 'styled-components';

export const Wrapper = styled.div<{ width: number; typeToggle: boolean; disableMargin?: boolean }>`
  width: ${({ width }) => `calc(${width}% - 16px)`};
  margin: ${({ disableMargin }) => (disableMargin ? '0' : '16px 8px 0')};
  display: flex;
  flex-flow: ${({ typeToggle }) => (typeToggle ? 'row nowrap' : 'column nowrap')};
  justify-content: ${({ typeToggle }) => (typeToggle ? 'space-between' : 'flex-start')};
  align-items: ${({ typeToggle }) => (typeToggle ? 'center' : 'stretch')};
  padding: ${({ typeToggle }) => (typeToggle ? '12px 0' : '0')};

  &.TOGGLE + .TOGGLE {
    border-top: 1px solid var(--colorBlueGray200);
    margin-top: 0;
  }

  & + .TOGGLE {
    margin-top: 0;
  }
`;

export const Label = styled.label<{ typeToggle: boolean }>`
  color: ${({ typeToggle }) =>
    typeToggle ? 'var(--colorBlueGray1200)' : 'var(--colorBlueGray600)'};
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.24px;
  line-height: 16px;
  margin-bottom: ${({ typeToggle }) => (typeToggle ? '0' : '8px')};
  display: block;
`;

export const Description = styled.span`
  color: var(--colorBlueGray1200);
  font-size: 12px;
  font-weight: 400;
  letter-spacing: 0.24px;
  line-height: 16px;
  display: block;
`;

export const Error = styled.span`
  color: red;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.24px;
  line-height: 16px;
`;
